export default {
    _prefix: "Scorable",
    labels: {
        details: "Details ",
    },
    metadata: {
        labels: {
            agent: "Agent",
            assignee: "Assignee",
            evaluator: "Evaluator",
            createdDate: "Created",
            originalCreatedDate: "Original Created",
            revisionCreatedDate: "Revision Created",
            releasedDate: "Released",
            modifiedDate: "Form Version",
            disputeCount: "Disputes",
            version: "Retracted Version",
            surveyType: "Survey Type",
        },
        evaluationSource: {
            User: "Created By User",
            Policy: "Created By Policy",
            Unknown: "Created By",
        },
        unassigned: "Not Assigned",
        notApplicable: "N/A",
        unknown: "Unknown",
        virtualSupervisor: "Virtual Supervisor",
        status: {
            inprogress: "In Progress",
            pending: "Pending",
            complete: "Complete",
            inreview: "In Review",
            retracted: "Retracted",
            calibration: "Calibration",
            partialResponse: "Partial Response",
        },
        web: "Web",
        voice: "Voice",
    },
    contextWarning: {
        adminEvaluator:
            "You are the agent on this evaluation, but you are viewing it as an evaluator. {{#toggleLink}}View the evaluation as an agent.{{/toggleLink}}",
        admin: "You are the agent on this evaluation, but you are viewing it as a supervisor. {{#toggleLink}}View the evaluation as an agent.{{/toggleLink}}",
        agentEvaluator:
            "You are viewing this evaluation as the agent on the evaluation. {{#toggleLink}}View the evaluation as an evaluator.{{/toggleLink}}",
        agent: "You are viewing this evaluation as the agent on the evaluation. {{#toggleLink}}View the evaluation as a supervisor.{{/toggleLink}}",
    },
};
